
    // THIS FILE IS AUTO-GENERATED via 'yarn build-trans' !!

    export default {
        locale: 'hu_HU',
        messages: {
			"graphical_template": "Grafikai sablon",
			"fill": "Töltő",
			"none": "Nincs",
			"shape_color": "Kitöltőszín",
			"shape_position": "Elhelyezés",
			"shape_size": "Méret",
			"triangle": "Háromszög",
			"square": "Négyzet",
			"square_format": "Négyzet alakú",
			"wide": "Szélességben",
			"width": "Szélesség",
			"stroke_width": "Körvonal szélessége",
			"stroke_color": "Körvonal színe",
			"text_stroke_width": "A szöveg körvonalának szélessége",
			"text_stroke_color": "Szöveg körvonalának színe",
			"frame_image": "Kép keretezése",
			"color": "Szín",
			"side": "Oldal",
			"text": "Szöveg",
			"text_color": "Szövegszín",
			"text_fontsize": "Szövegméret",
			"text_font": "Betűtípus",
			"triangle_orientation": "Háromszög tájolása",
			"search": "Keresés",
			"up": "Felül",
			"down": "Alul",
			"show_frame": "Keret megjelenítése",
			"dashed": "Szaggatott vonal",
			"frame_color": "Keretszín",
			"frame_width": "Keretszélesség",
			"frame_width_placeholder": "Keretszélesség pixelben",
			"show_stripe": "Sáv megjelenítése",
			"stripe_color": "Sávszín",
			"stripe_position": "Sáv elhelyezése",
			"horizontal": "Vízszintes sáv",
			"vertical": "Függőleges sáv",
			"stripe_text_placeholder": "Sávszöveg",
			"shape_text_placeholder": "Szöveg alakzatban",
			"text_size_placeholder": "szövegméret",
			"text_font_placeholder": "betűtípus",
			"nav_queries": "Termékek",
			"nav_size": "Formátum",
			"nav_frame": "Keret",
			"nav_filter": "Szűrő",
			"nav_stripe": "Sáv",
			"nav_shape": "Réteg",
			"nav_image": "Kép",
			"nav_save": "Mentés",
			"nav_shapes": "Rétegek",
			"upscale_image": "Felbontásjavítás",
			"template_type_null": "Grafikai sablon",
			"template_type_1": "Felbontás javítása",
			"template_type_2": "Háttéreltávolítás",
			"template_type_3": "Vízjelek eltávolítása",
			"template_type_4": "Outpainting",
			"template_type_5": "Animált GIF",
			"template_type_6": "Inpainting",
			"template_type_10": "Kép eltávolított vízjellel",
			"template_type_11": "Kép eltávolított háttérrel",
			"template_type_1_started": "Képfeljavítás folyamatban",
			"template_type_2_started": "Háttéreltávolítás folyamatban",
			"template_type_3_started": "Vízjeleltávolítás folyamatban",
			"template_type_4_started": "A kifestés folyamatban van",
			"template_type_6_started": "A festés folyamatban van",
			"template_type_1_done": "Kép feljavítva",
			"template_type_2_done": "Képháttér eltávolítva",
			"template_type_3_done": "Vízjel eltávolítva",
			"template_type_4_done": "Kifestés megtörtént",
			"template_type_6_done": "Befestés hotov",
			"outpainting_error": "Túlfestési hiba",
			"outpaint_over": "Kifesteni a teljes vászonra",
			"upscale_previews_all_done": "Az előnézetek generálása megtörtént. Tömeges felbontásjavításhoz válassza ki a jobb oldali panelen a terméklekérdezést, amelyre a javítást alkalmazni szeretné. Ne felejtse el elnevezni és elmenteni a sablont.",
			"min_detection_accuracy": "minimális detektálási pontosság",
			"min_detection_accuracy_info": "ha kisebb a detektálási pontosság, megmarad az eredeti vízjeles kép",
			"get_previews": "Előnézetek generálása",
			"select_images_for_upscale_previews": "Válassza ki a képeket, amikből felbontásjavító előnézetet szeretne készíteni.",
			"creating_upscale_previews": "A képek előnézetének generálása folyamatban. Ez a művelet időigényes, így eltart egy darabig.",
			"sending_images_for_upscale_previews": "Képek küldése",
			"original_image": "Eredeti kép",
			"other_images": "Egyéb képek",
			"bgremoved_image": "Szerkesztett kép, háttér eltávolítva",
			"bgremoved_edited_image": "Kép eltávolított háttérrel",
			"wmremoved_image": "Kép eltávolított vízjellel",
			"upscaled_image": "Feljavított kép",
			"no_images_for_upscale": "Nem található 600 x 600 pixelnél nagyobb méretű kép a feedjében. A felbontás javítása nem szükséges.",
			"upscale_template": "Képek felbontásjavítása",
			"upscale_how_does_it_work": "<h3>Hogy működik?</h3><p>....</p>",
			"upscale_method_preview": "Felbontásjavítás szemléltetők",
			"image_is_upscaled": "Kép felbontásjavítással",
			"show_larger_preview": "Nagyobb előnézet megjelenítése",
			"upscale_loading_products": "A feedjében található képek méretének elemzése. A felbontásjavításnak csak max. 600 x 600 pixel méretű kép esetében van értelme.",
			"upscale_clear_interval": "Visszavonás és más képek kijelölése",
			"clear_selection": "Kijelölés visszavonása",
			"selected_count": "Kijelölve",
			"cancel": "Visszavonás",
			"position": "Pozíció",
			"opacity": "Áttetszőség",
			"apply_on_queries": "Alkalmazás termékekre",
			"template_name": "Sablon neve",
			"template_type": "Típus",
			"save_template": "Sablon mentése",
			"show_shape": "Réteg megjelenítése",
			"stroke_opacity": "Szegélyek áttetszősége",
			"priority": "Prioritás",
			"template_list": "Sablonlista",
			"products": "Termékek",
			"images": "Képek",
			"count_images": "képek száma",
			"validations": "Képek validálása",
			"new_template": "Új sablon",
			"new_upscale_template": "Képek felbontásjavítása",
			"new_bgremove_template": "Háttér eltávolítása",
			"new_wmremove_template": "Vízjel eltávolítása",
			"template_gallery": "Sablongaléria",
			"blank_template": "Üres sablon",
			"background_color": "Háttérszín",
			"text_background_color": "Háttérszín",
			"background_width": "Szélesség",
			"background_height": "Magasság",
			"background_type": "Háttértípus",
			"background_type_none": "Nincs",
			"background_type_circle": "Kör",
			"background_type_rectangle": "Téglalap",
			"background_type_rectangle-each-line": "Téglalap soronként",
			"background_type_ellipse": "Ellipszis",
			"background_type_image": "Kép",
			"random_product": "Random termék",
			"stroke": "Szegély",
			"full": "Telt",
			"no_templates": "Még nincs sablonja. Hozza létre az elsőt!",
			"no_alternative_templates": "Még nincsenek alternatív sablonjaid.",
			"all_products": "Összes termék",
			"back": "Vissza",
			"back_to_template_list": "Vissza a sablonlistára",
			"due_date": "Esedékesség",
			"created_at": "Létrehozva",
			"save": "Mentés",
			"save_and_exit": "Mentés és bezárás",
			"save_and_apply": "Mentés és alkalmazás",
			"save_as_new_template": "Mentés új sablonként",
			"apply": "Alkalmazás",
			"saving": "Mentés folyamatban",
			"no_shape_selected": "Nincs kiválasztva réteg.",
			"user": "Felhasználó",
			"delete": "Törlés",
			"insert": "Beillesztés",
			"preview": "Előnézet",
			"pause": "Szüneteltetés",
			"start": "Indítás",
			"action": "Művelet",
			"edit": "Szerkesztés",
			"next": "Következő",
			"previous": "Előző",
			"project": "Export",
			"eshop": "E-shop",
			"agency": "Ügynökség",
			"freelancer": "Szabadúszó",
			"title": "Cím",
			"date": "Dátum",
			"created_by": "Létrehozó",
			"max_length": "Maximális hossz: 1000 karakter",
			"chars_left": "Fennmaradó karakterszám",
			"monday": "Hétfő",
			"tuesday": "Kedd",
			"wednesday": "Szerda",
			"thursday": "Csütörtök",
			"friday": "Péntek",
			"saturday": "Szombat",
			"sunday": "Vasárnap",
			"mon": "H",
			"tue": "K",
			"wed": "SZ",
			"thu": "CS",
			"fri": "P",
			"sat": "SZ",
			"sun": "V",
			"yes": "Igen",
			"no": "Nem",
			"currency": "Ft",
			"filter": "Szűrés",
			"calcel_filter": "Szűrő eltávolítása",
			"name": "Név",
			"confirm_delete": "Tényleg törölni szeretné ezt a sablont?",
			"margin": "Margó",
			"add_shape_button": "Új réteg",
			"add_shape": "Új réteg hozzáadása",
			"shape_list": "Réteglista",
			"diameter": "Átmérő",
			"active": "Aktív",
			"active_from": "Aktiváció kezdete",
			"active_to": "Aktiváció vége",
			"inactive": "Inaktív",
			"set_active_date": "Sablon aktivitása",
			"timer": "Időzítő",
			"invalid_active_date_range": "Érvénytelen dátumtartomány",
			"circle": "Kör",
			"frame": "Keret",
			"rectangle": "Téglalap",
			"triangle1": "Háromszög",
			"triangle2": "Háromszög",
			"triangle_side_length": "Oldalhossz",
			"corner_radius": "Lekerekítés",
			"dynamicText": "Feedelem",
			"imageFromElements": "kép elemből",
			"curvedText": "Szöveg görbe mentén",
			"circleText": "Szöveg a kör mentén",
			"textWithElements": "Szöveg elemekkel",
			"background_settings": "Háttérbeállítások",
			"text_wrap": "Szövegcsomagolás",
			"text_overflow": "Szöveg túlcsordulása",
			"text_overflow_keep": "változatlanul hagy",
			"text_overflow_fontsize": "betűméret csökkentése",
			"text_overflow_layersize": "réteg növelése",
			"text_decoration": "Vonal",
			"text_decoration_color": "Vonalszín",
			"text_decoration_linethickness": "Vonalvastagság",
			"text_decoration_lineoverlap": "Vonalátfedés",
			"text_decoration_none": "nincs",
			"text_decoration_underline": "aláhúzás",
			"text_decoration_overline": "föléhúzás",
			"text_decoration_linethrough": "áthúzás",
			"text_direction": "Szöveg iránya",
			"text_align": "Szövegigazítás",
			"text_align_left": "balra",
			"text_align_right": "jobbra",
			"text_align_center": "középre",
			"text_valign": "Függőleges igazítás",
			"text_valign_start": "fel",
			"text_valign_middle": "középre",
			"text_valign_end": "le",
			"height": "Magasság",
			"aspect_size_ratio": "Oldalarány fenntartása",
			"dash_length": "Szaggatások hossza",
			"dash_density": "Hézagok",
			"dashedFrame": "Szaggatott keret",
			"coordinate_x": "x koordináta",
			"coordinate_y": "y koordináta",
			"template_saved": "Sablon elmentve.",
			"upload_error_unsupported_type": "Nem támogatott fájltípus",
			"upload_error_large_file": "A fájl túl nagy. A maximális méret 1MB.",
			"upload_error_image_too_big": "A kép méretei túl nagyok. Kérjük, méretezze át a képet, és próbálja újra.",
			"active_templates": "Aktív sablonok",
			"type": "Típus",
			"file_too_big": "A fájl túl nagy. A maximális méret 0,5 MB",
			"file": "Fájl",
			"bitmap": "Kép",
			"polygon": "Poligon",
			"bezier": "Görbe",
			"line": "Vonal",
			"line_cap": "Vonalvégződés",
			"line_join": "Vonali csatlakozás",
			"line_cap_round": "lekerekített",
			"line_cap_inherit": "-",
			"line_cap_butt": "levágott",
			"line_cap_square": "négyzetes",
			"line_join_inherit": "-",
			"line_join_miter": "éles sarok",
			"line_join_round": "lekerekített",
			"line_join_bevel": "levágott sarok",
			"collage_layouts": "Kollázsok",
			"add_layout_button": "Egyéni",
			"save_as_new_collage": "Mentés új kollázsként",
			"preview_for_format": "Formátum előnézet",
			"no_custom_sets": "Még nincs egyéni képkészlete",
			"custom_image_set_add": "Egyéni képkészlet létrehozása",
			"custom_image_set_remove": "Képkészlet törlése",
			"custom_image_set_remove_image": "Kép törlése a készletből",
			"custom_image_set_selected_image": "Kijelölt kép",
			"custom_image_set_selected": "Képek a készletből",
			"custom_set_name": "Képkészlet neve",
			"custom_image_set_no_set_selected": "Készlet kiválasztása",
			"custom_image_set_no_images_yet": "Ebben a készletben még nincs kép.",
			"custom_image_set_no_image_selected": "Kép kiválasztása",
			"custom_image_set_uploaded": "A kép fel lett töltve a készletbe",
			"custom_image_set_cannot_remove_is_used": "A képet az egyik sablon használja! Nem törölhető.",
			"custom_image_set_cannot_remove_success": "A kép törölve.",
			"custom_image_set_deleted_success": "A készlet törölve",
			"custom_image_set_delete_set_is_used": "A készlet nem törölhető, egyes képeket sablonok használnak.",
			"scale": "Méret",
			"adjust_size": "Termékméret testreszabása",
			"enlarge": "Képméret korrekció",
			"no_enlarge_nor_crop": "nincs korrekció",
			"duplicate": "Sablon duplikálása",
			"horizontal_flip": "Vízszintes tükrözés",
			"vertical_flip": "Függőleges tükrözés",
			"flip": "Függőlegesen",
			"flop": "Vízszintesen",
			"rotation": "Elforgatás",
			"elements": "Az elem neve, amiből a tartalom beillesztendő",
			"xml_element_name": "Elem neve",
			"rating_xml_element": "Egy elem minősítéssel",
			"rating_count_xml_element": "Számos minősítéssel rendelkező elem",
			"rating_max_value": "Maximális érték egy értékelt elemben",
			"rating_hide_empty": "Csak akkor, ha a hírcsatorna összes eleme elérhető",
			"rating_min_stars": "Értékelések megjelenítése innen",
			"no_rating_yet": "Még senki sem értékelte ezt a terméket",
			"empty_element": "<AZ ELEM ÜRES>",
			"imagick_fonts": "Betűtípus",
			"imagick_fonts_family": "Betűtípuscsalád szűrése",
			"imagick_fonts_style": "Stílus",
			"imagick_fonts_info": "Figyelmeztetés: a dinamikus szöveg egyes betűtípusai gyors előnézetben nem állnak rendelkezésre, ezért az előnézeti kép eltérhet a generált képtől. Kérjük, használja az Előnézet gombot a kiválasztott betűtípusú szöveg megjelenítéséhez.",
			"render_preview": "Előnézet",
			"rotate_right": "Forgatás jobbra",
			"rotate_left": "Forgatás balra",
			"image_enlargment": "Kép nagyítása",
			"format": "Formátum",
			"first": "Első",
			"last": "Utolsó",
			"previews": "Előnézetek",
			"more_previews": "További előnézetek",
			"edit_template": "Sablon szerkesztése",
			"no_templates_this_size": "Ilyen sablon még nincs",
			"all_templates": "Összes sablon",
			"reload_images": "További előnézetek",
			"show_unmodified": "Eredeti megjelenítése",
			"show_modified": "Módosítottak megjelenítése",
			"help": "Súgó",
			"manage_templates": "Sablonok kezelése",
			"inactive_templates": "Inaktív sablonok",
			"show_template": "Sablon megjelenítése",
			"no_image": "A termékhez nincs kép.",
			"active_templates_only": "Csak aktív sablonok",
			"unmodified_images": "Eredeti képek",
			"allow_cache": "Gyorsítótár engedélyezése",
			"no_products_in_query": "A sablonhoz tartozó szűrők nem tartalmaznak termékeket. Random termékek kerülnek megjelenítésre az XML feedből.",
			"size_format": "Méret",
			"add_new": "Új hozzáadása",
			"new": "Új",
			"format_name": "Formátum neve",
			"select_format": "Válasszon egyet a kimeneti formátumok közül...",
			"query_is_required": "Legalább egy termékszűrőt ki kell választani",
			"format_name_is_required": "Ki kell tölteni a méret nevét",
			"width_is_required": "Szélességnek nagyobbnak kell lennie, mint 0",
			"height_is_required": "A magasságnak nagyobbnak kell lennie, mint 0",
			"bad_file_format": "Nem megengedett fájlformátum",
			"name_is_required": "Ki kell tölteni a sablon nevét",
			"error_loading_image": "Képbetöltési hiba",
			"confirm__bulk_delete": "Tényleg törölni szeretné a kijelölt sablonokat?",
			"svg_change_colors": "Színek módosítása",
			"apply_color_change": "Színváltoztatás alkalmazása",
			"load_image_error": "Nem sikerült betölteni a képet.",
			"badge": "Matrica",
			"badges": "Matricák",
			"icons": "Ikonok",
			"search_badges_or_icons": "Keressen grafikai elemeket vagy ikonokat",
			"tags": "Címkék",
			"emoji": "Emoji",
			"change": "Módosítás",
			"summer": "Nyár",
			"borders": "Keretek",
			"rating": "Értékelés",
			"rating_source": "Értékelés forrása",
			"xml_element": "XML element",
			"depots_extension": "Depots extension",
			"depots_not_enabled": "Ha a Depots-t szeretné képértékelések forrásaként használni, aktiválja ingyenesen a <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>-ban.",
			"rating_from_element": "Termékértékelések",
			"star_symbol": "Csillag szimbólum",
			"active_only": "Csak aktív",
			"dynamic_only": "Csak dinamikus",
			"autumn": "Ősz",
			"showroom": "Sablon előnézetek",
			"translate": "Eltolás",
			"crop": "Kép kivágása",
			"image_format": "Termékkép mérete",
			"enlarge_hint": "Termékkép mérete úgy van beállítva, hogy mindig kitöltse a kért formátumot (az oldalarány fenntartásával).",
			"crop_hint": "Ha a termékkép nagyobb, mint a beállított formátum, automatikusan levágásra kerül.",
			"winter": "Karácsony",
			"vertical_align_center": "Függőleges középre igazítás",
			"horizontal_align_center": "Vízszintes középre igazítás",
			"enlarge_by": "A kép méretének beállítása a kívánt méretnek megfelelően",
			"by_width": "kép szélessége",
			"by_height": "kép magassága",
			"by_smaller": "kisebb képméret",
			"by_bigger": "nagyobb képméret",
			"by_fit": "a kimeneti formátum méreteihez igazodva",
			"max_image_width": "Maximális képszélesség (px)",
			"max_image_height": "Maximális képmagasság (px)",
			"by_max_size": "Maximális méret beállítása (px)",
			"by_overscan": "Átfedés beállítása (px)",
			"overscan": "Védőövezet",
			"overscan_hint": "Itt beállíthatja, hogy a kép hány pixellel legyen kicsinyítve az eredeti formátum méretéhez képest. Itt beállíthat pozitív vagy negatív értéket. Pozitív értékkel az eredeti kép keretezését éri el a beállított háttérszínnel, negatív nagyítással.",
			"enlarge_by_hint": "Itt kiválaszthatja, hogy a termékképeket milyen formátummérethez szeretné igazítani. Az oldalarány minden forráskép esetében mindig fenntartásra kerül.",
			"enlarge_by_blog_link": "Részletesebb magyarázat",
			"error_save_template": "Hiba történt a sablon mentése során",
			"free-delivery": "Ingyenes szállítási napok",
			"black-friday": "BLACK FRIDAY   &   CYBER MONDAY",
			"valentine": "Valentin-nap",
			"easter": "Húsvét",
			"generic": "Univerzális sablonok",
			"source_image": "Forráskép",
			"sourceImage": "Forráskép",
			"edit_shape": "Rétegszerkesztés",
			"new_shape": "Új réteg",
			"modal_close": "Bezárás",
			"done": "Kész",
			"general_error": "Hiba",
			"validation_error_fields.queries": "Nincs kiválasztva termék.",
			"validation_error_fields.shapes": "A sablon üres.",
			"validation_error_queries": "Nincs kiválasztva termék.",
			"validation_error_size.id": "Nincs kiválasztott képformátum.",
			"validation_error_name": "Nincs megadva név.",
			"validation_error_setName": "Nincs megadva készletnév",
			"validation_error_visual_similarity_templateids": "Válassza ki azokat a sablonokat, amelyekben hasonló termékeket szeretne keresni.",
			"shape_name": "Rétegnév",
			"shape_badge_set_change": "Készletváltás",
			"delete_shape": "Réteg törlése",
			"edit_done": "OK",
			"loading": "Betöltés folyamatban...",
			"low_contrast": "Alacsony kontraszt",
			"same_image_in_preview": "Ugyanaz a termék előnézetben",
			"processed_at": "Feldolgozás dátuma",
			"total_processed": "feldolgozva",
			"with_status_ok": "hiba nélkül",
			"with_status_error": "hibásak",
			"without_images": "képek nélkül",
			"image_link": "Képhivatkozás",
			"content_length": "Fájlméret",
			"probability": "Valószínűség",
			"showGroup": "Csoport",
			"user_set": "Felhasználó által beállítva",
			"status_code": "állapotkód",
			"error": "hiba",
			"status_null": "?",
			"status_0_0": "A feldolgozás időpontjában nem áll rendelkezésre",
			"status_200_0": "Sikeres kérés",
			"status_200_null": "Sikeres kérés",
			"status_200_1": "Nullás képméret",
			"status_200_435": "Hiányzó sablon",
			"status_200_425": "Too Early",
			"status_200_450": "Ismeretlen formátum",
			"status_500_0": "Belső szerverhiba",
			"status_503_0": "A szolgáltatás nem elérhető",
			"status_400_0": "Rossz kérés",
			"status_404_0": "Az oldal nem található",
			"status_404_null": "Az oldal nem található",
			"status_403_0": "Nincs jogosultság",
			"status_200_420": "Ismeretlen formátum",
			"status_429_0": "Túl sok kérés",
			"status_200_465": "A kép magassága vagy szélessége meghaladja a korlátot",
			"status_too_many_alts": "Túl sok alternatív kép",
			"status_same_images": "Azonos képpel rendelkező termékek",
			"status_empty_images": "Hiányzó képek",
			"status_empty_images_description": "Hiányzik a termékekhez tartozó IMGURL elem az XML feedben. A termékek nem kapcsolódnak képekhez, vagy a képfájlok teljesen hiányoznak. Ennek következtében nem jelennek meg sem a webáruházában, sem az árösszehasonlító oldalakon. ",
			"status_unavailable_description": "A képeket tároló weboldal nem található.",
			"status_unsupported_mime_type_description": "A fájlformátum, amelyre az URL hivatkozik, nem szabványos képformátum. A termékképek nem jelennek majd meg a webáruházban.",
			"status_invalid_url_description": "Az árösszehasonlító oldalak elutasíthatják a termékképeket, ha az URL túl hosszú, vagy olyan karaktereket tartalmaz, amelyeket a kritériumok nem engedélyeznek. Gyakori probléma az írásjel vagy szóköz a kép nevében.",
			"has_watermark_description": "Ha vízjelekkel védi a termékképeket, számoljon azzal, hogy a Heureka, a GLAMI, a FAVI vagy a Google Shopping típusú hirdetési rendszerek ezeket a termékeket nem fogják megjeleníteni.",
			"status_wrong_placement_description": "Ideális esetben a termékek a lehető legnagyobb helyet foglalják el a képen, és középre vannak rendezve. Ellenkező esetben elveszítik információs értéküket, és nem keltenek egységes benyomást.",
			"status_poor_quality_images_description": "Ha a termékképek nem elég élesek, glitch-t tartalmaznak vagy más módon elmosódottak, rossz minőségükkel elriaszthatják a vásárlókat.",
			"status_seo_large_file_description": "<h3>Javaslat leírása:</h3> A kép mérete meghaladja a 400 kB-ot. Ez negatívan hat webáruházára, mivel hosszú ideig tart a betöltésük, ami pedig az elhagyási arány növekedéséhez vezethet.<br/><h3>Megoldás részletezés:</h3> A Feed Image Editor tömegesen tömöríti a túlméretezett képeket, csökkentve ezáltal méretüket, hogy gyorsabban betöltődjenek az oldalon. Többet olvashat erről <span class=link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>blogunkon</span>.",
			"status_few_alt_images_description": "<h3>A probléma részletes leírása:</h3> Az árösszehasonlító oldalak, melyeken hirdetni szeretne, a termékekhez alternatív képek megjelenítését is lehetővé teszik. A következő termékekhez nem áll rendelkezésre egyetlen alternatív kép sem.<br/><h3>Megoldás:</h3> Egészítse ki alternatív képekkel a feedjét, és használja ki maximálisan az árösszehasonlító oldalak nyújtotta lehetőségeket. Blogcikkünkből megtudhatja, hogyan találhat képeket a termékekhez.",
			"status_transparent_background_description": "A legtöbb hirdetési rendszer és árösszehasonlító oldal íratlan szabálya a termékképek fehér háttere. Ha egy kép háttere áttetsző, a rendszer elutasítja, vagy automatikusan hozzáadja a hátteret, így szemcsésnek fog tűnni.",
			"status_same_images_description": "Egyes termékek azonos képekkel rendelkeznek, például ruházat esetében a méretváltozatok, autóalkatrészek illusztrációs képei vagy az immateriális termékek. Más esetben ez nem kelt jó benyomást.",
			"alternative_images_description": "A termékek több alternatív képpel rendelkeznek, mint amennyit az árösszehasonlító oldal engedélyez. Ezek az extra képek nem jelennek meg az árösszehasonlító keresőben. Vegye ezt figyelembe, és csak a legmegnyerőbb alternatív képeket hirdesse.",
			"status_poor_quality_images": "Képminőség",
			"status_seo_large_file": "A képfájlok mérete SEO szempontból",
			"status_few_alt_images": "Alternatív képek hozzáadásának lehetősége",
			"status_all": "Összes termék",
			"status_unavailable": "Nem elérhető képek",
			"status_invalid_url": "Érvénytelen URL-cím",
			"status_unsupported_mime_type": "Nem támogatott formátum",
			"status_wrong_placement": "Pozíció, igazítás és a termék mérete a képen",
			"status_transparent_background": "Áttetsző háttér",
			"unsupported_mime_by_engines": "Az árösszehasonlító oldal által nem támogatott képek: Az árösszehasonlító oldal, melyen hirdetni szeretne, nem támogatja az exporthoz választott fájlformátumot. A kimeneti formátumot a beállításoknál módosíthatja.",
			"supports_formats": "támogatott formátumok",
			"with_problems": "hibákkal",
			"clear_old_products": "Régi termékek törlése az adatbázisból",
			"info_is_new": "Még nincs importált termék. Úgy tűnik, hogy a szabályokat még nem futtatták le ezen a projekten.",
			"info_no_data": "Egyetlen termék sem felel meg a beállított szűrőknek.",
			"info_not_processed_yet": "A feldolgozás és a diagnosztika folyamatosan történik a nap folyamán.",
			"info_apply_one_rule": "Ha több sablonja van ugyanarra a termékre, csak a legmagasabb prioritású sablon kerül alkalmazásra. Az egyes sablonokhoz tartozó termékválasztékot a termékek fülön választhatja ki a sablon szerkesztésekor.",
			"filter_image_url": "Képhivatkozás",
			"filter_product_url": "Termékhivatkozás",
			"filter_product_urls": "Termékhivatkozások",
			"fulltext": "Teljes szöveges keresés",
			"input_list": "Adjon meg több címet vesszővel vagy sortöréssel elválasztva",
			"more": "Több",
			"less": "Kevesebb",
			"filter_status_code": "Állapotkód",
			"filter_template": "Sablon",
			"filter_from": "Kezdődátum",
			"filter_to": "Végdátum",
			"filter_productname": "Terméknév",
			"filter_productid": "MERGADO termékazonosító",
			"filter_element": "Elem",
			"filter_element_value": "Elemérték",
			"filter_value_from": "Kezdet",
			"filter_value_to": "Vég",
			"filter_add": "Elem",
			"filter_remove": "Töröld <br/>az összes szűrőt",
			"filter_group": "Csoport",
			"filter_content_type": "Képformátum",
			"filter_content_length": "Méret",
			"custom_filter": "Egyéni szűrő",
			"preset_ranges": "Előre beállított tartományok",
			"filter_mistake_set_by_user": "Felhasználó által beállított állapot",
			"filter_correctness_percentage_offset": "Szegélytől való távolság",
			"filter_has_alpha": "Áttetsző háttér",
			"filter_status_reason": "Állapot oka",
			"filter_status": "Állapot",
			"filter_probability": "Az előfordulás valószínűsége [%]",
			"filter_user_set_watermark": "Vízjel a képen (felhasználó)",
			"filter_user_set": "Felhasználó által beállított állapot",
			"watermarks": "Vízjelek",
			"images_quality": "Minőségi állapot",
			"quality_status": "Képek minősége",
			"bad_quality_score": "Gyenge minőségi pontszám",
			"good_quality": "Jó",
			"bad_quality": "Rossz",
			"middle_quality": "Közepes",
			"diagnostics": "Diagnosztika",
			"processed_alt_images": "Feldolgozott alternatív képek",
			"processed_images": "Feldolgozott képek",
			"problems": "Problémák",
			"warnings": "Figyelmeztetések",
			"recommendations": "Javaslatok",
			"overview": "Áttekintés",
			"watermarks_removal": "Vízjelek eltávolítás",
			"selected_watermark_pattern": "Ez a kép szolgál a keresett vízjel mintájaként",
			"select_watermark_pattern": "Hozzáadás a vízjelet tartalmazó mintákhoz",
			"user_set_objects": "Felhasználó által megjelölt vízjel pozíciók",
			"with_or_without_objects": "Megjelölt vízjelek",
			"with_objects": "Megjelölt vízjelekkel",
			"without_objects": "Megjelölt vízjelek nélkül",
			"all": "Összes",
			"view_mode": "Megjelenítés",
			"problems_text": "Ennyi terméknél <b>nem jelenik meg termékkép</b>, mert legalább egy felmerült az alábbi problémák közül:",
			"warnings_text": "Ennyi terméknél <b>korlátozva van a képek megjelenítése</b>, mert legalább egy felmerült az alábbi figyelmeztetések közül:",
			"recommendations_text": "Ennyi terméknél <b>nem jelenik meg termékkép</b>, mert legalább egy felmerült az alábbi problémák közül:",
			"one_product": "termék",
			"less_than_five_products": "termék",
			"products_count": "termék",
			"image_id": "Kép ID szám",
			"mistake_set_by_user": "Felhasználó által beállított hiba",
			"correctness_percentage_offset": "Szegélytől való távolság",
			"has_alpha": "Áttetszőség",
			"status_reason": "Állapot oka",
			"status": "Állapot",
			"updated_at": "Frissítve",
			"no_alpha": "Nem",
			"with_alpha": "Igen",
			"info_status_suspicious": "Nem felismerhető, hogy szándékosan van-e így elhelyezve a kép",
			"vertical_image": "Függőleges kép",
			"horizontal_image": "Vízszintes kép",
			"image_down": "Kép lent",
			"image_up": "Kép fent",
			"image_right": "Kép jobbra",
			"image_left": "Kép balra",
			"image_in_the_middle": "Kép középen",
			"image_could_not_be_read": "A kép nem olvasható",
			"unknown_image_format": "Ismeretlen formátum",
			"option_false": "Nem",
			"option_true": "Igen",
			"option_not_set": "Nincs beállítva érték ",
			"mistake_by_user_successfully_changed": "Módosított érték",
			"status_N/A": "Gyanús",
			"status_ERROR": "Hiba",
			"status_OK": "OK",
			"status_NOT_OK": "Nincs rendben",
			"status_NOT_DETECTED": "Nem található",
			"importance_HIGH": "Magas",
			"importance_MEDIUM": "Közepes",
			"importance_SMALL": "Alacsony",
			"filter_is_active": "A szűrő aktív",
			"export_to_csv": "Exportálás",
			"csv_download_started": "CSV fájl generálása, kérjük várjon",
			"csv_download_success": "Fájl létrehozva",
			"csv_download_error": "Hiba történt a csv-be történő exportálás során",
			"shop_link": "Link a webáruházba",
			"unmodified_link": "Eredeti kép",
			"modified_link": "Kép sablonon keresztül",
			"total_products": "Termék",
			"total_images": "Kép",
			"total_alt_images": "Alternatív képek",
			"total_products_info": "A MERGADÓBÓL importált termékek összesen",
			"no_products_yet": "Még nincs importált termék ehhez a sablonhoz.",
			"total_processed_products_info": "Előfeldolgozott termékek összesen",
			"product": "Termék",
			"product_category": "Kategória",
			"product_links": "Hivatkozások",
			"eshop_product": "Termék a webáruházban",
			"barcode_lookup": "Termék a BarcodeLookup-ban",
			"product_name": "Termék",
			"product_no": "Termékszám",
			"product_code": "Termékkód",
			"product_image": "Kép",
			"product_template": "Sablon",
			"product_image_link": "Képhivatkozás",
			"element_item_id": "Termék ID",
			"element_url": "Link a webáruházba",
			"element_cpc": "CPC",
			"element_name": "Terméknév",
			"element_img_url": "Képhivatkozás",
			"element_img_url_input": "Kimeneti kép címe",
			"element_alt_img_url": "Kimeneti alternatív képcím",
			"element_alt_img_url_input": "Adja meg az alternatív képcímet",
			"element_price_vat": "Ár ÁFÁ-val",
			"element_delivery_date": "DELIVERY_DATE",
			"element_manufacturer": "Gyártó",
			"element_categorytext": "Kategória",
			"element_ean": "EAN",
			"element_productno": "Termékszám",
			"element_accessory": "Kiegészítő",
			"element_gift": "Ajándék",
			"element_itemgroup_id": "ITEMGROUP_ID",
			"advanced_search": "Speciális keresés",
			"export_is_ready": "Az export elkészült. ",
			"download": "Letöltés",
			"please_wait_generating_export": "Kérjük, várjon, az exportálás folyamatban",
			"please_wait_generating_export2": "Ezt az ablakot bezárhatja. Amint elkészül az export, megjelenik egy értesítés a letöltési linkkel.",
			"click_to_download_export": "Az export letöltéséhez kattintson a Letöltés gombra.",
			"exported": "Exportálva",
			"close": "Bezárás",
			"n_products": "termék",
			"template_exported": "A sablon exportálása megtörtént",
			"export_template": "Sablon exportálása",
			"import_template": "Sablon importálása",
			"link_image_url": "Képhivatkozás",
			"link_fie": "Kép a Feed Image Editor-ból",
			"link_mergado": "Termék a MERGADÓBAN",
			"link_eshop": "Termék a webáruházban",
			"template_not_found": "A sablon nem található!",
			"template_preview": "Előnézet",
			"template_is_dynamic": "Sablon dinamikus elemekkel",
			"input_width": "Bemeneti kép szélessége",
			"input_height": "Bemeneti kép magassága",
			"product_content_type": "Képformátum",
			"product_content_length": "bemeneti méret [kB]",
			"rendered_content_length": "kimeneti méret [kB]",
			"copy_to_clipboard": "Vágólapra másolás",
			"copy_mergado_query": "MERGADO lekérdezés másolása a vágólapra",
			"copied_to_clipboard": "átmásolva",
			"products_per_page": "A termékek száma az előnézeti lapon",
			"layer_copied": "A réteget a vágólapra másolva",
			"ask_save_before_leave": "Előfordulhat, hogy a módosítások nem kerülnek mentésre, ha kilép.",
			"ask_save_before_leave_title": "Kilépés mentés nélkül?",
			"ask_save_before_leave_leave": "Kilépés",
			"ask_save_before_leave_stay": "Marad",
			"history_undo": "Mégsem",
			"history_redo": "Mégis",
			"history_initial": "Összes visszavonása",
			"settings": "Beállítások",
			"confirm_delete_format": "A formátum törlése",
			"confirm_delete_format_yes": "Igen",
			"confirm_delete_format_no": "Nem",
			"templates_having_this_size": "Sablonok ezzel a formátummal",
			"project_settings": "Projekt beállítások",
			"ui_settings": "Felhasználói felület beállításai",
			"output_image_format": "Kimeneti formátum beállítása",
			"output_image_compression": "Kimeneti kép tömörítése",
			"auto_compression_to_size": "Automatikus tömörítés méretre",
			"group_by_image": "Csoportosítás kép alapján",
			"products_per_page_on_list": "Termékek oldalanként",
			"ask_before_leave": "A szerkesztőből való kilépés előtt rákérdezni a módosítások mentésére",
			"settings_value": "érték",
			"settings_update_success": "Beállítások elmentve",
			"settings_update_error": "Hiba történt a beállítások mentése során",
			"save_sizes_success": "Formátum elmentve",
			"save_sizes_error": "Hiba történt a formátum mentése során",
			"different_hash": "Az adatok nem biztos, hogy aktuálisak",
			"filtered_items": "Szűrt tételek",
			"set_template_active_date_success": "Dátum beállítva",
			"set_template_active_date_error": "Nem sikerült beállítani a dátumot",
			"from_date": "kezdődátum",
			"to_date": "végdátum",
			"is_active": "aktív",
			"not_active": "inaktív",
			"is_date_limited": "Aktiváció kezdete - vége",
			"active_now": "Azonnal aktív",
			"set_timer": "Időzítő beállítása",
			"show_more": "Mutass többet...",
			"show_less": "Mutass kevesebbet...",
			"output_image_preview": "Kimeneti kép előnézete",
			"output_image_content_length": "Méret",
			"original_output_image_content_length": "Eredetileg",
			"less_than_original": "kevesebb, mint eredetileg",
			"more_than_original": "több, mint eredetileg",
			"about": "About",
			"has_no_watermark": "Nem tartalmaz vízjelet",
			"has_watermark": "Vízjelet tartalmaz",
			"watermark_status": "Vízjel a képen",
			"hiding_products": "Termékek elrejtése",
			"hide_products_by_filter": "Termékek elrejtése szűrő szerint",
			"unhide_products": "Elrejtés felfedése",
			"hidden_by_filter": "Szűrővel elrejtve",
			"hide_by_has_watermark": "Vízjeles termékek elrejtése",
			"hide_by_wrong_placement": "Rossz képelhelyezésű termékek elrejtése",
			"hide_by_low_quality": "Alacsony minőségű termékek elrejtése",
			"hide_by_seo_large_file": "A SEO szempontjából nagy képfájllal rendelkező termékek elrejtése",
			"filter_content_length_gt": "A tartalom hossza nagyobb, mint ... [kB]",
			"filter_content_length_lt": "A tartalom hossza kisebb, mint ... [kB]",
			"set_by_user": "Felhasználó által beállítva",
			"filter_empty_content": "Üres képtartalom",
			"filter_no_image": "Nincs kép",
			"is_collage": "Elrendezés",
			"all_available_only": "Csak akkor, ha az összes alternatív kép elérhető",
			"single_image": "Egy termékkép",
			"collage_layout": "Válasszon elrendezést",
			"export_layouts": "Elrendezések exportálása",
			"import_layouts": "Elrendezések importálása",
			"export_gradients": "Színátmenetek exportálása",
			"import_gradients": "Színátmenetek importálása",
			"main_image": "Kép",
			"alt_image": "Alt",
			"alternative_images": "Alternatív képek",
			"save_layouts_error": "Hiba történt a mentés során",
			"save_layouts_success": "Elmentve",
			"delete_layouts_error": "Hiba történt az elrendezés törlése során. Az elrendezést sablon használja",
			"delete_layout_image_error": "Hiba történt a kép törlésekor az elrendezésből",
			"delete_layouts_success": "Törölve",
			"add_layout_image_success": "Kép hozzáadva az elrendezéshez",
			"add_layout_image_error": "Hiba történt az elrendezési kép hozzáadása során",
			"create_default_layouts": "Alapértelmezett elrendezéskészlet újbóli létrehozása",
			"create_default_layouts_success": "Alapértelmezett elrendezés sikeresen létrehozva",
			"create_default_layouts_error": "Hiba az alapértelmezett elrendezés létrehozása során",
			"delete_all_unused": "Az összes használaton kívüli törlése",
			"delete_all_unused_success": "Sikeresen törölve",
			"delete_all_unused_error": "Hiba a törlés során",
			"layout_name": "Elrendezésnév",
			"selected_layout_image": "Kijelölt kép",
			"add_layout": "Elrendezés hozzáadása",
			"delete_layout": "Elrendezés törlése",
			"delete_layout_image": "Elrendezési kép törlése",
			"add_layout_image": "Elrendezési kép hozzáadása",
			"save_all_layouts": "Az összes elrendezés mentése",
			"save_layout": "Elrendezés mentése",
			"padding_px": "Kép eltolása [px]",
			"assigned_image": "Hozzárendelt kép",
			"units": "Egységek",
			"layout_pos": "Pozíció",
			"layout_size": "Méret",
			"add_layout_success": "Új elrendezés hozzáadva",
			"add_layout_error": "Hiba történt az elrendezés hozzáadása során",
			"template_sizes": "Kimeneti képméret",
			"save_order": "Beállítási sorrend mentése",
			"save_settings_order_success": "Beállítási sorrend elmentve",
			"save_settings_order_error": "Hiba a beállítási sorrend mentése során",
			"import_template_success": "Sablon importálva",
			"import_template_error": "Hiba történt a sablon importálása során",
			"representative_colors": "Reprezentatív színek a képből",
			"shortcuts": "Gyorsbillentyűk",
			"shortcut_ins": "Új réteg beillesztése",
			"shortcut_del": "Réteg törlése",
			"shortcut_save": "Sablon mentése",
			"shortcut_undo": "Mégsem",
			"shortcut_redo": "Mégis",
			"shortcut_copy": "Réteg másolása",
			"shortcut_paste": "Réteg beillesztése",
			"product_is_rendering": "Előnézet generálása",
			"product_is_loading": "A termék betöltése folyamatban",
			"is_saving": "Mentés folyamatban",
			"invalid_filed_value": "Érvénytelen mezőérték",
			"value_not_set": "nincs beállítva",
			"font_not_found": "A betűtípus nem található. Alapértelmezettre váltás.",
			"radius": "Sugár",
			"gradient_type_linear": "Lineáris",
			"gradient_type_radial": "Sugárirányú",
			"no_gradient": "Nincs gradiens",
			"select_gradient": "Gradiens kijelölése",
			"select_gradients": "Színátmenetek kiválasztása",
			"save_as_new_gradient": "Mentés új gradiensként",
			"info_gradients_not_saved": "A gradiens módosításai még nincsenek elmentve",
			"gradient": "Gradiens",
			"gradients": "Gradiensek",
			"confirm_remove_gradient": "Törölni akarja ezt a gradienst?",
			"palettes": "Színpaletták",
			"predefined_colors": "Előre definiált színek",
			"brand_colors": "Márkaszínek",
			"custom_colors": "Egyéni paletták",
			"select_palette": "Paletta kijelölése",
			"extract_colors_from_image": "Színek kivonása a képből",
			"add_to_custom_palettes": "Hozzáadás az egyéni palettákhoz",
			"save_custom_colors": "Egyéni színek mentése",
			"save_as_default": "Mentés alapértelmezettként",
			"saved": "Elmentve",
			"no_changes": "Nincs módosítás",
			"no_custom_palettes": "Még nincs egyéni palettája",
			"create_layer_group": "Rétegcsoport létrehozása",
			"group": "Csoportosítás",
			"ungroup": "Csoportbontás",
			"delete_layer_group": "Rétegcsoport megszüntetése",
			"toggle_visibility": "Láthatóság átkapcsolása",
			"delete_layers": "Rétegek törlése",
			"delete_layer": "Réteg törlése",
			"duplicate_layer": "Réteg duplikálása",
			"duplicate_layers": "Rétegek duplikálása",
			"edit_layer": "Réteg szerkesztése",
			"lock_layer": "Réteg zárolása",
			"unlock_layer": "Réteg zárolásának feloldása",
			"thickness": "Vastagság",
			"brightness": "Fényerő",
			"contrast": "Kontraszt",
			"show_products": "Termékek megjelenítése",
			"reset_effects": "Effektek törlése",
			"auto_level": "Automatikus színegyensúly",
			"alpha": "Áttetszőség",
			"save_as_query": "Mentés<br/> szűrőként",
			"save_as_query_title": "Mentés szűrőként",
			"fie_query_type": "Típus",
			"fie_query_name": "Szűrőnév",
			"fie_query_element": "Az új elem neve a MERGADÓBAN",
			"fie_query_filter": "Termék szűrő",
			"fie_query_is_active": "Aktív",
			"query_in_use": "Ezt a lekérdezést sablonban használja",
			"fie_queries": "Szűrők",
			"fie_queries_info": "Szűrők - TODO: súgó",
			"no_fie_queries_yet": "Még nincs termékcsoportja. Termékcsoportot a termék szekcióban tud létrehozni.",
			"toggle_active": "Aktív/inaktív átkapcsolás",
			"set_active": "Aktív átkapcsolás",
			"set_inactive": "Inaktív átkapcsolás",
			"image": "Kép",
			"mergado_connection_verifying": "A MERGADÓVAL való kapcsolat ellenőrzése folyamatban",
			"show_in_mergado": "Mutasd a MERGADÓBAN",
			"mergado_queries": "Szűrők",
			"mergado_products": "Termékek",
			"mergado_formats": "Formátumok",
			"mergado_elements": "Elemeket",
			"output_image_element": "Kimeneti képelem",
			"output_image_hidden_warning": "Figyelmeztetés: az ilyen típusú exportnál a kimeneti képelem rejtett",
			"not_empty_error": "A mező kitöltése kötelező",
			"drop_shadow": "Árnyék",
			"shadow_color": "Árnyékszín",
			"shadow_opacity": "Áttetszőség",
			"shadow_sigma": "Elmosódás",
			"shadow_offset": "Eltolás",
			"shadow_xoffset": "X",
			"shadow_yoffset": "Y",
			"effect_sensitivity": "Effekt érzékenysége",
			"sensitivity": "érzékenység",
			"LOW": "alacsony",
			"MEDIUM": "közepes",
			"HIGH": "magas",
			"too_big_for_upscale": "A kép 600 x 600 pixelnél nagyobb, a felbontásjavítás nem alkalmazható. Kérjük, próbáljon meg betölteni egy másik véletlenszerű képet.",
			"only_main_image": "csak a fő kép",
			"other_effects": "További effektek",
			"flood_fill_points": "Pontok",
			"fuzz": "Szóródás",
			"heureka_175x175": "Heureka – ajánlott méret",
			"heureka_4096x4096": "Heureka – maximális méret",
			"zoot_1000x745": "Zoot – minimális méret",
			"zoot_1907x2562": "Zoot – ajánlott méret",
			"zbozi_425x440": "Zboží.cz – minimális méret",
			"zbozi_600x800": "Zboží.cz – minimális méret (használt áruk)",
			"google_100x100": "Google Merchants – minimális méret",
			"google_250x250": "Google Merchants – minimális méret ruházati képeknél",
			"google_500x500": "Google Merchants – minimális méretek *2027.01.31-től",
			"google_1500x1500": "Google Merchants – ajánlott méret",
			"glami_400x400": "GLAMI – minimális méret",
			"glami_1500x1500": "GLAMI – ajánlott méret",
			"alza_600x600": "ALZA – minimális méret",
			"alza_1000x1000": "ALZA – ajánlott minimális méret",
			"alza_1300x1300": "ALZA – ajánlott maximális méret",
			"favi_600x600": "FAVI – minimális méret",
			"favi_1000x1000": "FAVI – ajánlott méret",
			"biano_400x400": "BIANO – minimális méret",
			"biano_1500x1500": "BIANO – ajánlott méret",
			"shopalike_250x250": "Shopalike – minimális méret",
			"shopalike_1024x1024": "Shopalike – ajánlott méret",
			"instagram_1024x1024": "Instagram – ajánlott méret",
			"instagram_1080x1080": "Instagram",
			"instagram_1080x1350": "Instagram",
			"instagram_1080x566": "Instagram",
			"instagram_1080x1920": "Instagram",
			"instagram_1440x1800": "Instagram",
			"instagram_1440x2560": "Instagram",
			"allegro_500x500": "Allegro – minimális méret",
			"allegro_2560x2560": "Allegro – maximális méret",
			"facebook_1024x1024": "Facebook – ajánlott méret",
			"facebook_500x500": "Facebook – minimális méret",
			"facebook_600x600": "Facebook",
			"facebook_1080x1080": "Facebook",
			"facebook_1200x1200": "Facebook",
			"facebook_1080x1350": "Facebook",
			"facebook_1200x628": "Facebook",
			"facebook_1440x1440": "Facebook",
			"facebook_1440x1800": "Facebook",
			"facebook_1440x2560": "Facebook",
			"modio_500x500": "Modio – minimális méret",
			"modio_1024x1024": "Modio – ajánlott méret",
			"modio_2048x2048": "Modio – maximális méret",
			"mall_1280x1024": "Mall – minimális méret",
			"mall_2000x2000": "Mall – maximális méret",
			"kaufland_1024x1024": "Kaufland – minimális méret",
			"kaufland_2048x2048": "Kaufland – ajánlott méret",
			"snapchat_200x200": "Snapchat – minimális méret",
			"pinterest_200x300": "Pinterest – minimális méret",
			"pinterest_600x900": "Pinterest – minimális méret",
			"pinterest_1000x1500": "Pinterest – ajánlott méret",
			"pinterest_1080x1920": "Pinterest – ajánlott méret",
			"pinterest_1080x1080": "Pinterest",
			"find_format": "Formátum keresése",
			"custom_formats": "Egyéni formátumok",
			"other_formats": "További formátumok",
			"elements_availability": "Elemek elérhetősége dinamikus sablonokban",
			"product_elements": "Elemek",
			"filter_missing_elements": "Hiányzó vagy üres elemek szűrése",
			"only_updated_products": "Csak azok a termékek, amik a sablon mentése után megfeleltek a szabályoknak",
			"ok": "Ok",
			"empty_elements": "Üres elemek",
			"toggle_snap_to_guides": "Illesztés",
			"toggle_snap_to_grid": "Rácshoz igazítás",
			"toggle_snap_to_element": "Elemhez igazítás",
			"show_grid": "Rács",
			"snap_strength": "Illesztési erősség",
			"is_anim_gif": "Animált GIF",
			"outpainting": "Outpainting",
			"frames_delay": "Képkockák közötti késleltetés [ms]",
			"loops_delay": "Késleltetés a ciklus végén",
			"info_no_active_template": "Jelenleg nincs aktív sablonja. Ahogy aktivál egyet, a Feed Image Editor működni kezd.",
			"info_no_template": "<b>Nincs létrehozott sablonja.</b><br/>Válasszon egyet a galériában lévő kész sablonok közül, vagy hozzon létre saját sablont.",
			"info_workshop": "Tanulja meg száz százalékosan használni a Feed Image Editor. Iratkozzon fel ingyenes image marketing képzésünkre. <span class=link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/skoleni\")>Tudjon meg többet</span>.",
			"replace_color": "Színcsere",
			"target_color": "Célszín",
			"replace_by_color": "Csereszín",
			"add_point": "Pont hozzáadása",
			"info_no_points": "Pontokat a vászonra kattintva tud hozzáadni.",
			"projects_overview": "Projektek áttekintése",
			"system": "Rendszer",
			"project_info": "Projekt",
			"templates": "Sablonok",
			"random_images": "Random képek",
			"rules": "Szabályok",
			"queries": "Szűrők",
			"rabbit": "RabbitMQ",
			"points_coordinates": "Relatív pontpozíciók",
			"no_images_found": "Nincs képeket tartalmazó termék",
			"show_helper": "Súgó megjelenítése",
			"disable_helper": "Súgó elrejtése",
			"disable_wheelzoom": "Egérkerékkel való zoomolás letiltása",
			"helper_ok": "Ok",
			"helper_close": "Többször ne jelenjen meg",
			"helper": "Súgó",
			"need_help_title": "Segítségre van szüksége?",
			"need_help_text": "Ha bármilyen javaslata vagy problémája lenne, kérjük, lépjen kapcsolatba ügyfélszolgálatunkkal <a href=mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"bezier_no_points": "<ul><li class=\right-arrow-marker\">Új görbepont hozzáadásához kattintson a vászonra</li></ul>",
			"bezier_add_points": "<ul><li class=\right-arrow-marker\">Kattintson a vászonra, tartsa lenyomva a gombot, és az egér húzásával állítsa be a vezérlőpontokat. Majd engedje el a gombot, és további pontokat állíthat be.</li></ul>",
			"bezier_unselect": "<ul><li>Az aktív réteg módosításához használja a jobb egérgombot, vagy kapcsoljon át a réteglistára.</li></ul>",
			"has_reflection": "Tükörkép",
			"angle": "Szög",
			"reflection_offset": "Eltolás",
			"reflection_opacity": "Áttetszőség",
			"reflection_flip": "Tükrözés",
			"helper_no_queries": "<ul><li class=info-marker\">Válassza ki a termékcsoportot, amire alkalmazni szeretné a sablont. Használjon szűrőt a csoport kiválasztásához.</li></ul>",
			"helper_one_query": "<ul><li>Több szűrőt is választhat.</li></ul>",
			"helper_at_least_one_query": "<ul><li>A kiválasztottakat mindig a lista tetején találja.</li></ul>",
			"helper_zero_products_query": "<ul><li class=exclamation-marker\">A kiválasztott szűrő nem tartalmaz terméket.</li></ul>",
			"helper_no_format": "<ul><li class=info-marker\">Válasszon egyet az előre beállított kimeneti formátumok közül. Egyéni formátumot a lista végén vagy a Beállítások menüpontban tud létrehozni.</li></ul>",
			"helper_format_selected": "<ul><li>Válasszon egyet a képkorrekciós lehetőségek közül.</li><li>Az átfedés szélességét manuálisan módosítsa szükség szerint.</li></ul>",
			"helper_no_layer": "<ul><li class=info-marker\">Az Új réteg gombra kattintva szöveget, címkéket, ábrákat és egyéb elemeket adhat a képhez.</li></ul>",
			"helper_at_least_one_layer": "<ul><li>A rétegek sorrendje megváltoztatható a {ArrowVIcon} áthúzásával.</li><li>Az elemeket tartalmazó rétegek fix sorrendben a vászon tetején találhatók.</li><li>Ne felejtse el elnevezni és elmenteni a sablont.</li></ul>",
			"helper_two_more_layers": "<ul><li>Tartsa lenyomva a <span class=\framed\">CTRL</span> billentyűt, és használja a kurzort több réteg kijelöléséhez. A {GroupIcon} gombbal egy rétegbe csoportosíthatja azokat. Ugyanezzel a gombbal a rétegek szétválaszthatók.</li><li>A vezérvonalak megkönnyítik a rétegek összehangolását. Aktiválásához és deaktiváláshoz használja ezt a gombot {MagnetIcon}</li></ul>",
			"layers": "Rétegek",
			"brush_spacing": "Ecsettávolság",
			"brush_color": "Ecsetszín",
			"brush_pattern": "Minta",
			"brush_pattern_color": "Minta színe",
			"brush_rotate_pattern": "Forgatás minta",
			"linewidth_profile": "Vonalszélesség profil",
			"uniform": "egyenruha",
			"fade_out": "fokozatosan gyengül",
			"fade_in": "fokozatosan növekszik az erő",
			"fading": "hogy a végein legyengüljön",
			"zoom_in": "nagyítás",
			"zoom_out": "kicsinyítés",
			"token_not_provided": "Hitelesítési hiba - nincs megadva biztonsági token",
			"toast_online_call": "Tanácstalan, netán segítségre lenne szüksége az első képkampány létrehozásához? Beszéljen meg <span class=link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>egy online hívást Marekkel </span>, aki szívesen ad tanácsot, hogyan tudja a legtöbbet kihozni a Feed Image Editorból.",
			"online_call_header": "Szeretne segítséget a beállításban vagy ihletet a kampányaihoz?",
			"online_call": "Foglaljon egy rövid, ingyenes konzultációt Markkal. Megmutatja az Ön webáruház-típusához legjobb bevált gyakorlatokat, segít a beállításban, és megválaszol minden kérdést.",
			"watermark_mask": "Vízjel maszk",
			"watermark_masked_image": "Vízjel",
			"watermark_group": "Vízjel csoport",
			"watermark_groups": "Vízjel csoportok",
			"watermark_methods": "Vízjel eltávolítási módszerek",
			"create_new_group": "Új csoport létrehozása",
			"new_group": "Új csoport",
			"required_field": "Kötelező mező",
			"no_watermark_masks": "Még nincs kijelölt vízjele",
			"downloaded": "Letöltve",
			"status_ok": "Állapot OK",
			"waiting_to_process": "Feldolgozásra vár",
			"inpaint_error": "Vízjel eltávolítási hiba",
			"watermark_group_not_selected": "Először válasszon vízjel csoportot",
			"background": "Háttér",
			"remove_background": "Háttér eltávolítása",
			"solid_bg": "Monokróm",
			"light_bg": "Világos háttér",
			"dark_bg": "Sötét háttér",
			"background_colors": "Színek",
			"background_shade": "Háttér árnyalat",
			"not_transparent_bg": "Nem áttetsző háttér",
			"transparent_bg": "Áttetsző háttér",
			"multicolor_bg": "Sokszínű",
			"status_not_recommended_colorspace": "Színmodellek",
			"not_recommended_colorspace": "Színmodellek",
			"not_recommended_colorspace_description": "A képek CMYK színmodellűek, ezek nem alkalmas a számítógépek képernyőjén és mobileszközökön való megjelenítésre. Az ilyen képek elriasztják az ügyfeleket. Konvertálja a képeket RGB színmodellre.",
			"status_unsupported_background": "Képháttér",
			"unsupported_background": "Képháttér",
			"unsupported_background_description": "Az árösszehasonlító oldalak és a hirdetési csatornák eltérnek a termékképek hátterére vonatkozó követelményeikben.  Nagyrészük monokróm fehér hátteret igényel. Ha színes hátterű képeket vagy termékfotókat tölt fel, ezek a termékek nem kerülnek reklámozásra. Egyes árösszehasonlító oldalakon viszont lehet színes hátterű képeket használni.",
			"set_watermark_group_first": "Először állítsa be a vízjel csoportot!",
			"unknown_preview_image_error": "Képbetöltési hiba",
			"render_preview_error_6": "Ismeretlen domain",
			"render_preview_error_1": "Üres forráskép",
			"render_preview_error_420": "Ismeretlen formátum",
			"render_preview_error_450": "CRC hibás PNG kép",
			"render_preview_error_28": "A képet tartalmazó szerver nem válaszol",
			"render_preview_error_35": "SSL hiba",
			"first_steps_wizard": "Első beállítás varázsló",
			"skip_wizard": "Nincs szükségem varázslóra, szeretnék áttérni az alkalmazásba",
			"close_wizard": "Varázsló bezárása",
			"input_elements_map": "Bemeneti elemek beállítása",
			"input_output_format": "Bemeneti és kimeneti formátum beállítások",
			"first_steps_create_template": "Kész. Minden készen áll az első sablon létrehozásához.",
			"first_step_info": "Üdvözöljük a Feed Image Editor alkalmazásban, amely segít Önnek a webáruház termékképeit tömeges szerkeszteni a piactereken, közösségi hálókon és árösszehasonlító oldalakon történő használathoz.<br/>Először válassza ki a csatornát, amelyen hirdetni szeretne:",
			"first_step_info_old": "Üdvözöljük a Feed Image Editor alkalmazásban, amely segít Önnek a webáruházában található képek szerkesztésében.<br/>Első lépésként, kérjük, ellenőrizze, hogy a megfelelő elemeket választottuk-e ki feedjéből a szerkesztőprogramban való használathoz. Ezt követően máris nekiláthat az első sablon létrehozásának.",
			"next_step": "Következő lépés",
			"previous_step": "Előző lépés",
			"input_format": "Bemeneti formátum",
			"output_format": "Kimeneti formátum",
			"preferred_product_preview": "Tekintse meg kedvenc termékét előzetesen",
			"date_placeholder": "NN. HH. ÉÉÉÉ",
			"today": "Ma",
			"news_box_header": "Nézze meg, milyen újdonságok vannak az alkalmazásban",
			"news_box_body": "<h4>Szerkessze termékképeit közvetlenül a csevegőablakból</h4><p>A Feed Image Editor immár MCP-szerverrel is rendelkezik, amely közvetlenül összeköti az olyan MI-asszisztenseket – mint például a Claude vagy a ChatGPT – a szerkesztőfelülettel. Ahelyett, hogy a menükben kattintgatna, egyszerűen írja be kérését a csevegőbe, és az asszisztens elvégzi a következőket:<ul><li>sablonok beállítása és paraméterek módosítása</li><li>termékek hozzárendelése kijelölés alapján</li><li>képméretezés, háttéreltávolítás és felbontásnövelés</li></ul><p>Ha már használ MI-asszisztenst Mergado MCP-n keresztül, a Feed Image Editor MCP-funkciója automatikusan működik – nincs szükség további beállításokra. Ha még nem dolgozott MCP-vel, egyszerűen kattintson a linkre, és pillanatok alatt csatlakoztathatja azt.</p>",
			"news_box_body_link": "Tudjon meg többet →",
			"select_template_queries": "Először válassza ki, hogy mely termékekre szeretné alkalmazni a sablont.",
			"set_output_image_size": "Állítsa be a kimeneti képek méretét",
			"select_from_template_gallery": "Választhat kész sablonjaink közül is",
			"main_image_or_collage": "Válassza ki, hogy csak a fő kép vagy a fő és az alternatív képek kollázsa legyen-e a kimeneten",
			"main_image_on_canvas_placement": "Helyezze a fő képet a vászonra",
			"set_collage_layout": "Állítsa be a kollázs végső megjelenését. A jobb hatás érdekében javasoljuk a háttéreltávolítás funkció aktiválását.",
			"set_anim_gif": "Állítsa be az animált GIF végső megjelenését",
			"position_and_rotation": "Pozíció és forgás",
			"apply_ai_effects_or_filters": "Alkalmazza az AI effektusokat vagy szűrőket a termékképen",
			"editor_step_5": "Válassza ki, hogy a sablon a létrehozás után azonnal vagy egy kijelölt napon kezdjen-e el működni",
			"editor_step_6": "A képek vizuális hasonlósága",
			"editor_step_7": "Adjon további rétegeket a képhez grafikus elemekkel",
			"helper_tips": "<ul><li>Saját betűtípust szeretne használni az alkalmazásban? Írjon nekünk support@feedimageeditor.com</li><li>Tudta, hogy a szerkesztőben gyorsbillentyűket is használhat?<div class='quote'><span class='framed'>Ins</span><span>Új réteg beillesztése</span><br/><span class='framed'>Del</span><span>Réteg törlése</span><br/><span class='framed'>Ctrl + s</span><span>Sablon mentése</span><br/><span class='framed'>Ctrl + z</span><span>Mégsem</span><br/><span class='framed'>Ctrl + y</span><span>Mégis</span><br/><span class='framed'>Ctrl + c</span><span>Réteg másolása</span><br/><span class='framed'>Ctrl + v</span><span>Réteg beillesztése</span></div></li></ul>",
			"more_fonts": "Saját betűtípust szeretne használni az alkalmazásban? Írjon nekünk <a href=mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"editor_step_0": "Sablontípus kiválasztása",
			"layout": "Képek elrendezése",
			"autoonoff": "Tevékenység tervező",
			"success": "Sikeres kérés",
			"zoom": "Nagyítás",
			"pan": "Eltolás",
			"draw": "Rajzolás",
			"move": "Mozgatás",
			"reset_zoom": "Eredeti nagyító",
			"queued_at": "Sorbaállítva",
			"score": "Pontszám",
			"ai_tools": "AI eszközök",
			"missing_symbols": "Ez a betűtípus nem tartalmazza az összes szimbólumot, az élő előnézet és a renderelt kép eltérhet.",
			"characters": "karakterek",
			"recently_used": "Legutóbb használt",
			"set_background": "Háttér beállítása",
			"filters": "Szűrők",
			"remove_background_error": "Hiba történt a képháttér eltávolításakor",
			"cannot_remove_background": "Az adott kép esetében a képhátteret nem lehet hitelesen eltávolítani.",
			"object_to_image_ratio": "Tárgy/kép",
			"template_id": "template id",
			"disable_show_overlap": "Ne mutassa a zónát az előnézetben",
			"font_example": "Egy hűtlen vejét fülöncsípő, dühös mexikói úr Wesselényinél mázol Quitóban.",
			"unsupported_mime_type": "Nem támogatott formátum",
			"unsupported_file_size": "A fájl túl nagy",
			"selection": "Szűrő",
			"is_transparent": "Áttetsző háttér",
			"is_light_bg": "Világos háttér",
			"orientation": "Képorientáció",
			"portrait": "Függőleges",
			"landscape": "Vízszintes",
			"bg_color_distance": "Színtávolság",
			"small_distance": "kicsi",
			"big_distance": "nagy",
			"medium_distance": "közepes",
			"bg_color": "Háttérszín",
			"create": "Létrehozás",
			"create_predefined_fie_queries_title": "Melyiket szeretné létrehozni az alábbi szűrők közül?",
			"create_predefined_fie_queries_text": "Elődefiniált FIE-lekérdezés létrehozása?",
			"active_supereffect": "Aktív szupereffekt",
			"not_number": "Nem szám",
			"prepared_text": "Előkészített szöveg",
			"get_now": "akció",
			"discount": "kedvezmény",
			"discount_and_frame": "Kedvezmény & keret",
			"1_plus_1_circle": "1 + 1 INGYEN",
			"buy_one_get_one_free": "1+1 ingyen",
			"last_piece": "Utolsó darab",
			"new_year_sale": "Újévi kiárusítás",
			"free_gift": "ingyenes ajándék",
			"add_to_cart": "kosárba",
			"sale": "kiárusítás",
			"buy_now": "vásárlás most",
			"buy": "vásárlás",
			"order_now": "rendelés most",
			"free_delivery": "ingyenes kiszállítás",
			"newie": "új",
			"in_stock": "raktáron",
			"project_health": "Projektállapot",
			"find_by": "Keresés",
			"fonts": "Betűtípusok",
			"send_mailgun_notifications": "Rendszerértesítések és tippek küldése e-mailben",
			"force_remove_alpha": "Az alfa-csatorna eltávolítása a képből, mielőtt azt háttéreltávolításra küldenék.",
			"auto_template_priority": "Sablonok automatikus újrarendezése",
			"no_watermark_mask_defined": "Először ki kell jelölni a vízjel helyét",
			"brush": "Ecset",
			"eraser": "Radír",
			"main_image_opt": "Fő kép",
			"layout_opt": "Kollázs",
			"skip_refresh_images": "Képek letöltése csak, ha az URL címük változik",
			"skip_refresh_images_hint": "Nem terheli annyira a szervert a tárolt képekkel. Megj: ha a kép url-je ugyanaz marad, csak a tartalom változik, ez a változás nem érzékelhető automatikusan.",
			"or": "vagy",
			"preferred_product_id": "Előnyben részesített ID",
			"random_product_id": "Betöltött termék",
			"other": "egyéb",
			"group_all_templates": "Összes sablon",
			"group_discounts_and_sales": "Akciók és kedvezmények",
			"group_black_friday": "Black Friday",
			"group_gift": "Ingyenes ajándék",
			"group_free_delivery": "Ingyenes kiszállítás",
			"group_new_year_sale": "Újévi kiárusítás",
			"group_viva_magenta": "Viva Magenta",
			"group_midjourney": "Midjourney",
			"group_generic": "Univerzális sablonok",
			"group_new": "Újdonságok",
			"group_seasonal": "Szezonális kampányok",
			"group_availability": "Elérhetőség",
			"group_christmas": "Karácsonyi kampány",
			"group_effects": "Effektek",
			"group_background": "Háttér",
			"group_warranty": "Garancia",
			"group_valentine": "Valentin-nap",
			"group_size_variant": "Méretvariációk",
			"custom": "Egyéni",
			"no_watermark_groups_yet": "Még nincs vízjel csoportja.",
			"no_watermark_groups_published_yet": "Még nincs elküldött vízjel csoportja.",
			"start_here": "Kezdje itt",
			"select_images_to_watermark_groups": "Válasszon ki néhány képet ugyanazzal a vízjellel.",
			"watermark_groups_info_0": "Minden vízjel típushoz több képet kell megjelölnie ugyanazzal a vízjellel. Ezek a képek kerülnek felhasználásra a modell tréninghez.",
			"watermark_groups_info_1": "todo",
			"images_from_mergado": "Képek a MERGADÓBÓL",
			"images_from_fie": "Termékképek a MERGADO szabályokból",
			"images_from_upload": "Feltöltött képek",
			"select_images_with_same_watermark": "Képek kiválasztása",
			"create_watermark_mask": "Fesse fel ecsettel a vízjelet",
			"create_watermark_group": "Létrehozás",
			"create_new_watermark_group": "Új képcsoport létrehozása",
			"append_to_watermark_group": "Csatolás",
			"to_wm_group": "csoporthoz",
			"add": "Hozzáadás",
			"add_image": "Kép hozzáadása",
			"no_watermark_mask": "Jelölje ki a vízjelet",
			"publish_to_trainer": "Tréningre küldés",
			"images_in_group": "Képek a csoportban",
			"rename": "Átnevezés",
			"group_exists": "Ilyen nevű csoport már létezik",
			"cannot_be_empty": "Nem lehet üres",
			"sent": "Elküldve",
			"confirm_remove_group_image": "Törölni szeretné a képet a vízjel csoportból?",
			"confirm_remove_group": "Vízjel csoport törlése",
			"empty_watermark_group": "A vízjel csoport nem tartalmaz képeket. Kezdjen el képeket feltölteni a csoportba.",
			"unpublished_group": "A csoport nem lett elküldve modell tréningre.",
			"watermark_group_hash_diff": "A csoport módosítva lett. Újra el kell küldeni tréningre.",
			"watermark_group_some_images_without_mask": "Néhány termék ebben a csoportban nem rendelkezik megjelölt vízjellel.",
			"spacing": "Hézagok",
			"line_spacing": "Sortávolság",
			"letter_spacing": "Betűtávolság",
			"lines_and_letters_spacing": "Szóközök a betűk között",
			"publish_to_detector": "Küldés a vízjel detektorba",
			"published": "Elküldve",
			"no_gradients_yet": "Még nincs létrehozott gradiens",
			"results": "Eredmények",
			"no_results_yet": "Még nincs eredmény",
			"template_name_max_100": "a név maximális hossza 100 karakter",
			"clockwise": "Az óramutató járásával megegyező irányban",
			"counter_clockwise": "Az óramutató járásával ellentétes irányban",
			"no_color": "nincs",
			"text_stroke": "Szövegvázlat",
			"text_stroke_underlayer": "Körvonal háttérként (a szöveg vastagsága változatlan marad)",
			"text_stroke_inside": "Körvonal a szöveg körül, a szöveg vastagságának rovására",
			"text_padding": "Szövegkitöltés",
			"select_format_to_see_templates": "A grafikus sablonok megtekintéséhez először válassza ki a kimeneti képformátumot.",
			"warn_inactive_fie_queries": "Ezek az előre meghatározott kijelölések nem aktívak",
			"warn_rules_not_applied_yet": "Ezek a kijelölések még nem szerepelnek a listában, mert a szabályok még nem futottak le",
			"random_colors": "Véletlenszerű színek",
			"random_gradients": "Véletlen színátmenetek",
			"dominant_color": "Szín a termékből",
			"warn_transparent_background": "Ha átlátszó <b>hátteret szeretne</b> a kimeneti képekhez>, válassza a .png formátumot a Beállítások menüpontban.",
			"import_palette": "Import paletta",
			"delete_palette": "Törölje a palettát",
			"add_color": "Szín hozzáadása",
			"group_easter_campaign": "Húsvéti kampány",
			"happy_easter": "Kellemes Húsvéti Ünnepeket",
			"easter_discounts": "Húsvéti kedvezmények",
			"easters": "HÚSVÉTI",
			"spring": "TAVASZI",
			"spring_sales": "Téli kiárusítás",
			"spring_discounts": "Tavaszi kedvezmények",
			"discounts": "ÉRTÉKESÍTÉS",
			"discount_30": "KEDVEZMÉNY 30%",
			"discounts_30": "KEDVEZMÉNYEK -30%",
			"up_to_20": "legfeljebb 20%",
			"right": "ÉPPEN",
			"now": "MOST",
			"click_here": "KATTINTS IDE",
			"buy_here": "VÁSÁRLÁS ITT",
			"watermark_mark_images": "Válasszon ki és címkézz fel 10–15 képet, amelyek ugyanazt a vízjelet tartalmazzák.",
			"watermark_max_images": "Max 15 kép",
			"watermark_min_images": "Min 10 kép",
			"marked_watermarks": "jelölt vízjelek",
			"not_published_yet": "még nincs elküldve",
			"text_orientation": "Szöveg tájolása",
			"horizontal_orientation": "vízszintesen",
			"vertical_orientation": "függőlegesen",
			"clip_mask": "Nyíró maszk",
			"add_clip_mask": "Vágómaszk hozzáadása",
			"invert_clip_mask": "Invert vágómaszk",
			"finish": "Befejez",
			"watermark_is_marked": "A vízjel meg van jelölve",
			"already_used_image": "A képet már használták",
			"check_elements_title": "Kézzel bevitt elemek elérhetőségének ellenőrzése",
			"some_elements_not_available": "A manuálisan beírt elemek egy része nem elérhető. A javasolt változtatások a következők:",
			"apply_all_suggested_changes": "Alkalmazza az összes javasolt változtatást",
			"apply_only_selected_changes": "Alkalmazza a kiválasztott módosításokat",
			"template_layer": "Sablon réteg",
			"e_img_url": "Kép url eleme",
			"e_img_url_input": "Írja be a kép URL-elemét",
			"e_alt_img_url": "Alternatív kép url elem",
			"e_alt_img_url_input": "Beviteli elem alternatív képcímmel",
			"e_item_id": "Elemazonosító elem",
			"e_name": "Terméknév elem",
			"e_productno": "Termékszám elem",
			"e_price_vat": "Ár elem",
			"e_url": "Bolt url eleme",
			"e_ean": "EAN elem",
			"template": "sablon",
			"layer": "réteg",
			"audit_promo_templates": "Minta sablonok az ellenőrzésben",
			"save_and_rerender_promo": "Save and re-render promo for existing projects",
			"reload_saved": "Reload saved",
			"back_to_predefined": "Back to predefined",
			"reset_filters": "Törölje a szűrőket",
			"has_complex_background": "Összetett háttér",
			"complex_background_threshold": "komplex háttér küszöbértéke",
			"empty_background_probability": "az üres háttér valószínűsége",
			"object_bounding_box_to_image_ratio": "objektumhatároló doboz képaránya",
			"set_template_size": "Sablon méreteinek beállítása (ajánlott)",
			"keep_original_image_size": "Tartsa meg a kép eredeti méreteit",
			"no_template_size_is_selected_title": "Hiányoznak a sablon méretei",
			"no_template_size_is_selected": "Nincsenek kiválasztott sablondimenziók. Ha más rétegek is vannak a sablonban, akkor azok a látható területen kívül lehetnek.",
			"gradient_stop_points": "gradiens végszínek",
			"is_autocrop": "Autocrop",
			"new_alternative_template": "Új alternatív képek sablon",
			"alternative_template": "Alternatív képek sablon",
			"alternative_templates": "Alternatív képsablonok",
			"main_templates": "Fő képsablonok",
			"image_offset": "A kép eltolása a meghatározott alakzathoz képest",
			"collage_image_shape": "Alak",
			"rect": "Téglalap",
			"ellipse": "Ellipszis",
			"selected": "Kiválasztott",
			"import": "Import",
			"no_templates_found": "Nem található sablon",
			"auto_priority": "Automatikus újrarendezése",
			"manual_priority": "Kézi rendezés",
			"right_now": "SHOP NOW",
			"limited_offer": "LIMITED OFFER",
			"sale2": "SALE",
			"sales_up_to_50": "UP TO 50%",
			"sale_up_to_50": "UP TO 50%",
			"sales_up_to": "SALE",
			"this_week": "THIS WEEK",
			"shop_here": "buy here",
			"discounts2": "DISCOUNTS",
			"textInsideShape": "Szöveg egy alakzaton belül",
			"element_not_selected": "nincs elem kiválasztva",
			"invalid_color": "érvénytelen szín",
			"invalid_email": "érvénytelen email cím",
			"letter_case": "Kis-és nagybetűk",
			"keep": "változtatások nélkül",
			"to_upper_case": "nagybetűvel",
			"to_lower_case": "kisbetűkre",
			"first_letter_to_upper_case": "első betű nagybetűvel",
			"first_letter_to_lower_case": "első betű kisbetű",
			"first_word_letter_to_upper_case": "a nagy szó első betűje",
			"has_person": "A person in the picture",
			"person_detected": "has person",
			"person_not_detected": "person not detected",
			"columns": "Szlopok",
			"is_keep_size": "Tartsa meg az eredeti formátumot",
			"is_keep_size_info": "Úgy döntött, hogy megtartja az eredeti méreteket. Nem lehet rétegeket beszúrni, csak effektusokat.",
			"contact_email": "Kapcsolattartó e-mail",
			"element_short_item_id": "ITEM_ID",
			"element_short_url": "URL",
			"element_short_cpc": "CPC",
			"element_short_name": "NAME",
			"element_short_img_url": "IMG_URL",
			"element_short_img_url_input": "IMG_URL",
			"element_short_alt_img_url": "IMG_ALTERNATIVE",
			"element_short_alt_img_url_input": "IMG_ALTERNATIVE",
			"element_short_price_vat": "PRICE_VAT",
			"element_short_delivery_date": "DELIVERY_DATE",
			"element_short_manufacturer": "MANUFACTURER",
			"element_short_categorytext": "CATEGORY",
			"element_short_ean": "EAN",
			"steps_first_perex": "<h4>Üdvözöljük a Feed Image Editor alkalmazásban</h4><p class='perex'>Segítünk gyorsan és egyszerűen szerkeszteni a termékképeket a webáruházához. Annak érdekében, hogy minden megfelelően működjön, közösen beállítunk néhány alapvető lépést.</p>",
			"steps_last_perex": "Most már elkezdheti tökéletesíteni termékképeit. Válassza ki, hogy az eredeti sablonban milyen szerkesztésekkel akar kezdeni.",
			"steps_first_header": "Ellenőrizze a Mergado feed elemeit",
			"steps_first_subheader": "Mielőtt elkezdené létrehozni az első sablont vagy kampányt, győződjön meg arról, hogy helyesen választottuk ki a termékfeed kulcselemeit. Ezek arra szolgálnak, hogy a képeken a megfelelő információk jelenjenek meg, például ár, név, márka vagy elérhetőség.",
			"steps_need_inspiration_perex": "Megtalálja azokat az Ön számára elkészített szerkeszthető sablonokban.",
			"steps_need_inspiration": "Inspirációra van szüksége?",
			"first_steps_title": "Első beállítás varázsló",
			"steps_third": "Maradjunk kapcsolatban",
			"steps_third_subscribe": "Feliratkozom a hírlevélre is",
			"create_first_template": "Első sablon létrehozása",
			"steps_create_blank": "CTA és grafikai elemek hozzáadása",
			"steps_create_resize": "Konkrét formátumra való átméretezés",
			"steps_create_upscale": "Minőség javítása",
			"steps_create_bg_removal": "Háttér eltávolítása",
			"steps_create_watermarks": "Vízjel eltávolítása",
			"steps_create_header": "Kész! Elkezdheti a munkát",
			"steps_create_perex": "Minden elő van készítve. Most már elkezdheti a termékképek szerkesztését és az első sablonok létrehozását.",
			"steps_who_are_you_title": "Hogy ajánlhassuk Önnek a megfelelő funkciókat és beállításokat, árulja el nekünk, ki Ön.",
			"steps_who_are_you_subtitle": "Így pontosan az igényeire szabjuk a szolgáltatásokat.",
			"steps_categorization_title": "Milyen típusú webáruházat üzemeltet?",
			"steps_categorization": "Válassza ki a kategóriát, amely a legjobban megfelel a kínálatának. A válasza alapján személyre szabottabb szolgáltatásokat tudunk nyújtani.",
			"steps_third_email": "Az Ön e-mail címe",
			"steps_third_sublabel": "Rendszerértesítéseket fogunk küldeni, amikor valami fontos történik.",
			"steps_second": "Kimeneti beállítások",
			"output_image_format_sublabel": "Válassza ki a képek kimeneti formátumát.",
			"output_image_compression_sublabel": "A tömörítés minőségi szintjének beállítása.",
			"auto_compression_to_size_sublabel": "Adatméret csökkentése",
			"steps_third_email_sublabel": "Ha bármilyen fontos dolog történne, értesítést küldünk Önnek.",
			"visual_similarity": "Vizuális hasonlóság",
			"ai_params": "Paraméterek hozzáadása termékekhez",
			"ai_params_generate": "Paraméterek generálása képekből a hírcsatornához",
			"ai_params_is_running_on_background": "A mesterséges intelligencia által végzett képelemzés és paramétergenerálás a háttérben történik.",
			"similar_images": "hasonló képek",
			"find_similar_images": "Keressen hasonló képeket",
			"searching_in_progress": "Keresés folyamatban",
			"create_list_and_publish_to_visual_similarity": "Exportáljon képeket egy sablonba, és keressen hasonlókat",
			"visual_similarity_last_update_at": "A vizuális hasonlóság funkció jelenleg le van tiltva. Az eredmények aktuálisak ",
			"image_cannot_be_downloaded": "A kép nem tölthető le",
			"product_has_no_image": "A terméken nincs kép",
			"missing_image_element": "Hiányzik egy képelem",
			"visual_similarity_enabled": "Hasonló képek keresése",
			"visual_similarity_n": "Hasonló képek száma",
			"visual_similarity_threshold": "Hasonlósági index",
			"visual_similarity_search_products_in": "Keressen hasonlót a sablonokban",
			"feature_enabled": "A funkció engedélyezve van",
			"feature_disabled": "A funkció le van tiltva",
			"upload_images": "Képek feltöltése",
			"download_images": "Képek letöltése",
			"download_image": "Kép letöltése",
			"upload_image": "Kép feltöltése",
			"uploaded_images": "Przesłane zdjęcia",
			"external_image": "Grafikai elemek",
			"blog_link": "https://www.feed-image-editor.com/blog",
			"please_select_templates": "Válassza ki azokat a sablonokat, amelyekben hasonló termékeket szeretne keresni",
			"loading_results": "Az eredmények betöltése",
			"exporting": "Termékeket exportálok",
			"task_queued": "Feladat sorban áll",
			"waiting_before_publish": "Várok a feladat elküldése előtt",
			"popup_box_header": "Important Announcement. We are changing price for Feed Image Editor",
			"popup_box_body": "<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"understand": "Megértem",
			"rerender": "Túlgenerálni",
			"redownload": "Újratöltés",
			"to_be_processed": "Még feldolgozásra vár",
			"similarity_less_than_n": "Nem található a kiválasztott számú hasonló kép az adott termékhez a hasonlósági index kiválasztott értékéhez. Fontolja meg a hasonlósági index értékének csökkentését.",
			"similarity_n_limit_info": "Állítsa be az adott termékhez keresendő hasonló képek számát. Előfordulhat, hogy egyes termékek nem feltétlenül erre a számra keresnek egy adott hasonlósági indexérték mellett. Ebben az esetben fontolja meg a hasonlósági index értékének csökkentését.",
			"similarity_threshold_info": "A hasonlósági index határozza meg, hogy a termékhez hogyan kell hasonló képeket keresni. Minél nagyobb az érték, annál hasonlóbbak a képek. Az 1-es érték pontosan ugyanazokat a képeket találja.",
			"fill_similarity_title": "Eredmények írása a kimeneti feedbe",
			"fill_similarity_ids_element": "A vizuálisan hasonló termékek azonosítói",
			"fill_similarity_image_urls_element": "A vizuálisan hasonló képek URL-címei",
			"no_items_filtered": "Nem találtunk válogatást",
			"no_match_with_element_regexp": "Az elem nem egyezik a szabályalkalmazás elemszűrőjével (element_regex)",
			"advanced_settings": "Speciális beállítások",
			"mergado_max_payload_size": "Az egy kérésben elküldött karakterek maximális száma. A maximális lehetséges érték 15 000 000 karakter.",
			"mergado_element_regex": "Reguláris kifejezés, amely szerint a projektelemek szűrve lesznek",
			"mergado_xml_equivalent": "Mergado XML-elemek, amelyek megfelelője az adott formátumnak, a Mergado-ból kerül elküldésre.",
			"suggested_elements_to_be_excluded": "Javasolt elemek, amelyeket kihagyhat a szabályok alkalmazása során",
			"alt_levels": "Alternatív sablonképszintek",
			"levels": "Alkalmazási szintek",
			"assigned_templates": "Hozzárendelt fő sablonok",
			"no_assigned_templates": "Nincsenek hozzárendelt sablonok",
			"necessary": "Szükségszerűen",
			"exclude_some": "Kijelölt kihagyása",
			"regexp": "Szabályos kifejezés",
			"mergado_apply_elements": "Mely elemeket kell elküldeni a FIE-nek a szabályok alkalmazásakor",
			"necessary_elements": "A FIE működéséhez szükséges elemek",
			"selected_mergado_equivalent": "Mergado elemek válogatott megfelelői",
			"categories": "Kategóriák",
			"fashion": "Divat",
			"beauty": "Szépség",
			"health": "Egészség",
			"pets": "Háziállatok",
			"electronics": "Elektronika",
			"home_and_garden": "Otthon és kert",
			"kids": "Gyerekek",
			"sports": "Sport",
			"books": "Könyveket",
			"cars": "Autók",
			"services_and_experiences": "Szolgáltatások és tapasztalatok",
			"other_category": "Más",
			"back_to_original": "Vissza a háttérben",
			"paint_transparent": "Távolítsa el a hátteret",
			"waiting_for_product_to_be_loaded": "Várakozás a termék betöltésére",
			"should_rerender": "Újra kellene renderelni",
			"should_redownload": "Újra kellene tölteni",
			"has_alt_images": "Alternatív képeket tartalmaz",
			"anim-gif": "Anim GIF",
			"auto-wmremove": "Vízjelek eltávolítása",
			"format_preset": "Előre elkészítve",
			"format_original": "Eredeti",
			"format_custom": "Egyedi",
			"turned_off": "kikapcsolva",
			"mode": "mód",
			"inpainting_create_mask": "Jelölje ki a festéshez szükséges területeket.",
			"inpainting_how_to_deal_with_diff_size": "Különböző maszk- és képméretek kezelése",
			"position_relative_to": "Pozíció relatívan",
			"scale_mask_to_image_size": "Maszk méretezése a kép méretéhez",
			"scale_to_size": "Méret testreszabása",
			"object_position": "Objektum pozíciója",
			"complex_background": "Komplex háttér",
			"edit_element_content": "Elem tartalmának szerkesztése",
			"prefix": "szöveg előtte",
			"suffix": "szöveg utána",
			"decimals": "ülőhelyek száma",
			"separator": "szétválasztó",
			"replace": "cserélni",
			"find_as_regexp": "reguláris kifejezésként keres",
			"symbol_table": "Speciális pénznemszimbólumok",
			"find_and_replace": "Keresés és csere",
			"add_text": "Szöveg beszúrása",
			"decimal_places": "Tizedesjegyek",
			"thousands_separation": "Ezresek elválasztása",
			"short_url_with_extension": "Rövidebb URL fájlkiterjesztéssel",
			"short_url_with_extension_info": "A kimeneti URL-cím rövidebb formája, amely a kimeneti képformátumnak megfelelő kiterjesztést tartalmaz. Egyes teljesítménymutatók képkiterjesztést igényelnek a címben.",
			"gradient_is_used_by_template": "Ezt a színátmenetet a sablon használja, és nem törölhető.",
			"no_search_image_results": "Nem található a keresési kifejezésnek megfelelő kép.",
			"import_from_project": "Importálás a projektből",
			"choose_project": "Válasszon egy projektet",
			"no_other_projects_of_user": "Nincsenek importálható projektek.",
			"loading_queries": "Kiválasztások betöltése Mergadoból",
			"loading_template": "A sablon betöltése",
			"text_mode": "Szöveges mód",
			"total_icons": "Összes ikon",
			"try_icons": "Próbáld ki az ikonokat.",
			"icon_color": "Ikon színe",
			"did_not_found_stickers": "Nem találtad meg a megfelelő matricákat?",
			"ai_elements_to_feed": "Takarmánydúsítás mesterséges intelligenciával",
			"mcp": "MCP",
            }
        }
    